import React from "react";
import useTheme from "../../../../common/hooks/useTheme";
import InfoIcon from "../../svg/InfoIcon";

export type BannerAction = {
  label: string;
  onClick: () => void;
  // "primary" (blue) is the default; "muted" is a secondary/grey action.
  variant?: "primary" | "muted";
  disabled?: boolean;
};

type InlineBannerProps = {
  text: string;
  backgroundColor?: string;
  iconColor?: string;
  // Single action (kept for backward compatibility) or a list of actions.
  action?: {
    label: string;
    onClick: () => void;
  };
  actions?: BannerAction[];
  marginBottom?: number;
  // Font size of the banner text (px). Defaults to 14.
  fontSize?: number;
};

const InlineBanner = ({
  text,
  backgroundColor = "",
  iconColor = "",
  action,
  actions,
  marginBottom = 16,
  fontSize = 14,
}: InlineBannerProps) => {
  const theme = useTheme();

  const allActions: BannerAction[] =
    actions ?? (action ? [{ ...action, variant: "primary" }] : []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor,
        border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
        borderRadius: 8,
        padding: 12,
        marginBottom,
        gap: 16,
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
        <div>
          <InfoIcon color={iconColor} size={12} />
        </div>

        <span
          style={{
            fontSize,
            fontFamily: "var(--font-Medium)",
            color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
          }}
        >
          {text}
        </span>
      </div>
      {allActions.length > 0 && (
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          {allActions.map((a, i) => (
            <span
              key={i}
              style={{
                fontSize: 12,
                fontFamily: "var(--font-Medium)",
                color:
                  a.variant === "muted"
                    ? theme.colors_ds.NEUTRAL_TEXT_WEAK
                    : theme.colors_ds.PRIMARY_TEXT_MAIN,
                cursor: a.disabled ? "default" : "pointer",
                opacity: a.disabled ? 0.5 : 1,
                whiteSpace: "nowrap",
              }}
              onClick={a.disabled ? undefined : a.onClick}
            >
              {a.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default InlineBanner;
